module.exports = __webpack_public_path__ + "1d8449ddfc4771c69e486df65e660bfb.pdf";